import { MouseEventHandler } from "react";
import { Box, Link, Typography } from "@mui/material";

import { T } from "../util/t";
import { Sx } from "utils/sx";

type ActionProps = {
    text: string | React.ReactNode;
    buttonText?: string | React.ReactNode;
    onClick?: () => void;
};

const actionStyles: Sx = (theme) => ({
    margin: theme.spacing(3, 0),
    textAlign: "center",
});

export const Action = ({
    text,
    buttonText,
    onClick,
}: ActionProps) => {
    const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
        event.preventDefault();
        onClick?.();
    };

    return (
        <Box sx={actionStyles}>
            <Typography color="textSecondary" component="span"><T>{text}</T></Typography>
            {onClick && " "}
            {onClick && <Link onClick={handleClick}><T>{buttonText}</T></Link>}
        </Box>
    );
};
